// @ts-nocheck
import {ClickableDiv} from '/ui/components/clickable/clickablediv';
import * as styles from '/ui/components/entitypicker/entitylist/itemlist.module.scss';
import ArrowDownIcon from '/ui/icons/inline/arrow-down.svg';
import ArrowRightIcon from '/ui/icons/inline/arrow-right.svg';
import {classNames} from '/ui/lib/classnames';


/**
 * @param {{
 *   icon: React.ReactNode,
 *   label: React.ReactNode,
 *   children: (React.ReactNode | undefined),
 *   initialCollapsed: (boolean | undefined),
 *   collapsible: (boolean | undefined),
 *   role: (string | undefined),
 * }} props
 * @returns {React.ReactElement}
 */
export const CollapsibleItem = ({
  icon,
  label,
  children,
  initialCollapsed = true,
  collapsible = true,
  role,
}) => {
  const [collapsed, setCollapsed] = React.useState(initialCollapsed);

  return (
    <li className={styles.collapsibleContainer}
      role={role}
      aria-expanded={!collapsed}>
      <ClickableDiv
        className={classNames(
          styles.item,
          styles.collapsibleItem,
          {[styles.collapsed]: collapsed},
        )}
        onClick={() => setCollapsed(!collapsed)}
      >
        <div className={styles.icon}>
          {collapsible && (collapsed ? <ArrowRightIcon /> : <ArrowDownIcon />)}
        </div>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.itemLabel}>{label}</div>
      </ClickableDiv>
      {
        !collapsed && <div className={styles.children}>
          {children}
        </div>
      }
    </li>
  );
};
